import RequesterV1 from "@/components/api/v1/requester.js";

export default {
  fetchAgroExporterProcess(agro_exporter_process_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/show_export_quality_inspect/agro_exporter_process/${agro_exporter_process_id}`
    );
  },
  fetchContainer(agro_exporter_process_id, container_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/list_templates/agro_exporter_process/${agro_exporter_process_id}/container/${container_id}`
    );
  },
  fetchExportQualityGroups(quality_template_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/show_export_quality_inspect/list_quality_groups/${quality_template_id}`
    );
  },
  destroyExportQualityInspect(quality_inspect_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/show_export_quality_inspect/${quality_inspect_id}/destroy`
    );
  },
  fetchTemplate({ container_id, quality_template_id }) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/show_export_quality_inspect/container/${container_id}/quality_template/${quality_template_id}`
    );
  },
  getExportQualityInspect(quality_inspect_id) {
    return RequesterV1.get(
      `agro_exporter/quality_control/container/show_export_quality_inspect/${quality_inspect_id}`
    );
  }
};
